import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Transition } from '@uirouter/core';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { SCHEDULE_ACCESS } from 'src/app/auth/types/access-level';
import { BaseEditableComponent } from 'src/app/shared/components/base-editable/base-editable.component';
import { ScheduleActionsService } from '../../services/schedule-actions.service';
import { ScheduleService } from '../../services/schedule.service';

@Component({
  selector: 'schedule-add',
  templateUrl: './schedule-add.component.html',
  styleUrls: ['./schedule-add.component.scss'],
  standalone: false,
})
export class ScheduleAddComponent extends BaseEditableComponent<any> {
  @ViewChild('scheduleForm')
  public scheduleForm: NgForm;

  actions = this.scheduleActionsService.getActions(this);

  constructor(
    public scheduleService: ScheduleService,
    private scheduleActionsService: ScheduleActionsService,
    private transition: Transition,
    private permissionService: PermissionService,
  ) {
    super();
    this.actions.saveAction = {
      id: 'saveButton',
      label: 'Save',
      action: () => this.save(),
      disabled: this.scheduleForm?.invalid,
      requireAccess: SCHEDULE_ACCESS.FULL_ACCESS,
    };
    this.oldObject = this.cloneDeep(this.scheduleService.schedule);
  }

  async save() {
    if (!this.permissionService.hasAccess(SCHEDULE_ACCESS.FULL_ACCESS)) {
      return;
    }

    if (!this.scheduleForm.valid || this.scheduleService.hasInsecureUrls()) {
      console.error('form not valid: ', this.scheduleForm.errors);
      return;
    }
    const folderId = this.transition.params().folderId;
    if (folderId) {
      this.scheduleService.schedule.folderId = folderId;
    }

    this.bypassUnsavedChanges();
    try {
      await this.scheduleService.addSchedule();
    } catch (e) {
      this.resetUnsavedChanges();
    }
  }

  canDeactivate(): boolean {
    return this.isDeepEqual(this.oldObject, this.scheduleService.schedule);
  }
}
